var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYinYangIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "86px",
    viewBox: "0 0 86 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tertiary-mental-health-assess copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.764622%",
    y1: "41.8176451%",
    x2: "24.2768159%",
    y2: "57.8163839%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.4375,14.78125 L56.4373853,14.7404116 C54.1582436,14.460929 52.40625,12.7808359 52.40625,10.75 C52.40625,8.5236021 54.5119108,6.71875 57.109375,6.71875 C58.5221554,6.71875 59.789443,7.25268921 60.6515565,8.09798378 C60.7382254,8.08516995 60.8271983,8.07572315 60.9171377,8.06981588 L60.9178213,8.0699364 L61.0124899,7.88090668 C61.7464909,6.49430276 63.153558,5.51880278 64.7984931,5.38960466 C65.7501482,2.28060811 68.8657798,0 72.5625,0 C76.7684125,0 80.2221314,2.95214691 80.5921818,6.71925553 L80.625,6.71875 C82.8513979,6.71875 84.65625,8.5236021 84.65625,10.75 C84.65625,10.7882646 84.6557169,10.8264048 84.6546576,10.8644133 C85.4380723,11.1400101 86,11.8871949 86,12.765625 C86,13.8788239 85.0975739,14.78125 83.984375,14.78125 C83.748862,14.78125 83.522783,14.740858 83.3126878,14.6666235 L83.3125,14.78125 L56.4375,14.78125 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.4%",
    y: "-23.7%",
    width: "120.8%",
    height: "147.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -3,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.764622%",
    y1: "41.1215767%",
    x2: "24.2768159%",
    y2: "58.4813194%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.87,76.59375 L3.86901713,76.5528 C1.6814666,76.2729821 0,74.5930659 0,72.5625 C0,70.3361021 2.02143435,68.53125 4.515,68.53125 C5.87152541,68.53125 7.08832487,69.0653909 7.91596319,69.9109628 C7.99893387,69.8976261 8.08487115,69.8881351 8.17174689,69.8822276 C8.84595645,68.3959201 10.2467668,67.3369595 11.8968768,67.2020782 C12.8102748,64.093007 15.8012272,61.8125 19.35,61.8125 C23.3877935,61.8125 26.703439,64.7648186 27.0585255,68.5320842 L27.09,68.53125 C29.227342,68.53125 30.96,70.3361021 30.96,72.5625 C30.96,72.6008166 30.9594868,72.6390084 30.9584672,72.6770683 C31.7101691,72.9519835 32.25,73.6993854 32.25,74.578125 C32.25,75.6913239 31.383671,76.59375 30.315,76.59375 C30.0884358,76.59375 29.8709662,76.5531892 29.6689181,76.4786584 L29.67,76.59375 L3.87,76.59375 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.9%",
    y: "-23.7%",
    width: "121.7%",
    height: "147.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -3,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.062500,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.500000)",
    id: "radialGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.093750,1.000000),rotate(90.000000),scale(1.000000,10.390143),translate(-0.489155,-0.509384)",
    id: "radialGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.0479062,0 C21.7915937,0 25.2692187,1.13815625 28.1515625,3.0879375 C28.417625,7.240125 27.5845,10.9999375 28.3665625,13.6565313 C29.7062812,18.2091562 35.6389375,22.3465625 32.8654375,24.6806562 C31.9879687,25.3820937 30.4802812,25.4277812 29.5920625,26.1184687 C28.1851562,27.2163125 29.1472812,28.4028438 29.27225,29.2615 C29.3327187,29.6686562 28.9645312,30.3230625 27.7444062,31.1172187 C28.6635312,31.7958125 28.5802187,32.3695937 28.2523437,32.8990313 C25.3498437,34.8904688 21.8345937,36.0568437 18.0479062,36.0568437 C8.0813125,36.0568437 0,27.9849375 0,18.02775",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.07992033e-05%",
    y1: "49.9984601%",
    x2: "100.000192%",
    y2: "49.9984601%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00126056055%",
    y1: "50.0004413%",
    x2: "100.00237%",
    y2: "50.0004413%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00267928098%",
    y1: "49.9979314%",
    x2: "100.005203%",
    y2: "49.9979314%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.6907963%",
    y1: "85.2718142%",
    x2: "85.3142653%",
    y2: "14.7090358%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-15",
    points: "0 0 4.69103125 0 4.69103125 4.68673125 0 4.68673125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.3869795e-15,15.7259063 C-2.3869795e-15,24.4105625 7.181,31.4518125 16.0349688,31.4518125 L16.0349688,31.4518125 C24.8902813,31.4518125 32.0699375,24.4105625 32.0699375,15.7259063 L32.0699375,15.7259063 C32.0699375,7.04125 24.8902813,0 16.0349688,0 L16.0349688,0 C7.181,0 -2.3869795e-15,7.04125 -2.3869795e-15,15.7259063 L-2.3869795e-15,15.7259063 Z",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.3869795e-15,15.7259063 C-2.3869795e-15,24.3890625 7.1460625,31.4182188 15.9718125,31.4504688 L15.9718125,31.4504688 C5.5765625,31.3886563 5.5980625,15.7259063 16.0349688,15.7259063 L16.0349688,15.7259063 C26.4947188,15.7259063 26.4947188,0 16.0349688,0 L16.0349688,0 C7.181,0 -2.3869795e-15,7.04125 -2.3869795e-15,15.7259063 L-2.3869795e-15,15.7259063 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.14571875 C0,4.88184375 1.435125,6.2914375 3.2061875,6.2914375 L3.2061875,6.2914375 C4.97859375,6.2914375 6.41371875,4.88184375 6.41371875,3.14571875 L6.41371875,3.14571875 C6.41371875,1.40959375 4.97859375,0 3.2061875,0 L3.2061875,0 C1.435125,0 0,1.40959375 0,3.14571875 L0,3.14571875 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.144375 C0,4.88184375 1.435125,6.29009375 3.2061875,6.29009375 L3.2061875,6.29009375 C4.97859375,6.29009375 6.41371875,4.88184375 6.41371875,3.144375 L6.41371875,3.144375 C6.41371875,1.40690625 4.97859375,-4.77395901e-15 3.2061875,-4.77395901e-15 L3.2061875,-4.77395901e-15 C1.435125,-4.77395901e-15 0,1.40690625 0,3.144375 L0,3.144375 Z",
    id: "path-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.261875 C0,9.71128125 2.8165,12.5250937 6.2699375,12.5250937 L6.2699375,12.5250937 C9.723375,12.5250937 12.5385313,9.71128125 12.5385313,6.261875 L12.5385313,6.261875 C12.5385313,2.81246875 9.723375,0 6.2699375,0 L6.2699375,0 C2.8165,0 0,2.81246875 0,6.261875",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00380773765%",
    y1: "49.997761%",
    x2: "100.003719%",
    y2: "49.997761%",
    id: "linearGradient-27"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB5D6",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HH---Dashboard_2nd_view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HH---Dashboard_2nd_view-A",
    transform: "translate(-604.000000, -482.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-tertiary-mental-health-assess-copy",
    transform: "translate(604.000000, 482.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(69.203125, 7.390625) scale(-1, 1) translate(-69.203125, -7.390625) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(16.125000, 69.203125) scale(-1, 1) translate(-16.125000, -69.203125) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    transform: "translate(0.000000, 80.625000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-7)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 43,
    cy: 2.6875,
    rx: 43,
    ry: 2.6875
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-8)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 43,
    cy: 2.015625,
    rx: 21.5,
    ry: 2.015625
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group-53",
    transform: "translate(10.750000, 4.031250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(20.714175, 2.291094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1538344,8.45621875 C15.4838969,8.45621875 17.3853031,6.55615625 17.3853031,4.22878125 C17.3853031,1.9000625 15.4838969,0 13.1538344,0 C10.8224281,0 8.92102187,1.9000625 8.92102187,4.22878125 C8.92102187,6.55615625 10.8224281,8.45621875 13.1538344,8.45621875",
    id: "Fill-1",
    fill: "#62EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6591906,11.7179031 C35.9234094,14.3677781 37.4767844,17.5215594 38.0895344,21.0892156 C38.9495344,26.1000594 37.6393781,30.7427156 38.5585031,33.8629031 C38.7573781,34.5414969 39.0610656,35.2120281 39.4198469,35.8677781 C37.5009719,36.9857781 35.2703469,37.6267469 32.8905656,37.6267469 C25.7216594,37.6267469 19.9099406,31.8217469 19.9099406,24.6609031 C19.9099406,17.5000594 25.7216594,11.6937156 32.8905656,11.6937156 C33.1485656,11.6937156 33.4052219,11.7031219 33.6591906,11.7179031",
    id: "Fill-3",
    fill: "#2CB5D6",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(10.190731, 20.205969)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1515625,3.0879375 C28.417625,7.240125 27.5845,10.9999375 28.3665625,13.6565313 C29.7062812,18.2091562 35.6389375,22.3465625 32.8654375,24.6806562 C31.9879687,25.3820937 30.4802812,25.4277812 29.5920625,26.1184687 C28.1851562,27.2163125 29.1472812,28.4028438 29.27225,29.2615 C29.3327187,29.6686562 28.9645312,30.3230625 27.7444062,31.1172187 C28.6635312,31.7958125 28.5802187,32.3695937 28.2523437,32.8990313 C25.3498437,34.8904688 21.8345937,36.0568437 18.0479062,36.0568437 C8.0813125,36.0568437 0,27.9849375 0,18.02775 C0,8.0705625 8.0813125,0 18.0479062,0 C21.7915937,0 25.2692187,1.13815625 28.1515625,3.0879375",
    id: "Fill-5",
    fill: "url(#linearGradient-11)",
    opacity: 0.78,
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.4792812,63.1359594 C27.6140625,65.9242406 18.4429687,56.5771156 17.2080625,75.6462719 C12.7884687,72.7894594 8.1081875,70.3223344 3.036875,68.4410844 C1.1206875,65.6326469 0,62.2410219 0,58.5873656 C0,48.9110219 7.852875,41.0675531 17.5399687,41.0675531 C27.2257187,41.0675531 35.07725,48.9110219 35.07725,58.5873656 C35.07725,60.1608969 34.8689687,61.6847094 34.4792812,63.1359594",
    id: "Fill-8",
    fill: "#2CB5D6",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4116375,63.2324406 C20.7888875,63.3856281 17.8689187,65.4684406 17.2091375,75.6460031 C12.8137312,72.8053156 8.160325,70.3489406 3.11991875,68.4717219 C3.2637,62.3280969 8.29335625,57.3911594 14.4772937,57.3911594 C18.7504187,57.3911594 22.4726062,59.7494406 24.4116375,63.2324406",
    id: "Fill-10",
    fill: "#2CB5D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(20.939388, 45.281687)",
    fill: "url(#linearGradient-12)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0406875,0.467625 C19.5985937,0.6154375 19.178,0.78340625 18.8434062,1.04275 C17.4365,2.14059375 18.398625,3.327125 18.5235937,4.18578125 C18.5840625,4.5929375 18.215875,5.24734375 16.99575,6.0415 C18.404,7.08021875 17.4553125,7.87571875 16.8895937,8.6403125 C14.2518125,10.5444063 17.9215937,14.65225 13.5705312,17.8423125 C9.18184375,19.6496563 3.84178125,16.463625 0.23784375,18.90925 C0.08196875,18.011625 0,17.0884688 0,16.1465 C0,7.229375 7.2374375,0 16.1639687,0 C17.4996562,0 18.7990625,0.16259375 20.0406875,0.467625",
    id: "Fill-12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79996875,33.0045156 C12.2187187,33.0045156 14.1926875,31.0332344 14.1926875,28.6171719 C14.1926875,26.2011094 12.2187187,24.2298281 9.79996875,24.2298281 C7.38121875,24.2298281 5.40725,26.2011094 5.40725,28.6171719 C5.40725,31.0332344 7.38121875,33.0045156 9.79996875,33.0045156",
    id: "Fill-21",
    fill: "#62EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8055,21.511825 C5.90040625,21.511825 7.60965625,19.8039188 7.60965625,17.7117 C7.60965625,15.6181375 5.90040625,13.9102313 3.8055,13.9102313 C1.70925,13.9102313 0,15.6181375 0,17.7117 C0,19.8039188 1.70925,21.511825 3.8055,21.511825",
    id: "Fill-23",
    fill: "#2CB5D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(8.292281, 3.653656)",
    fill: "url(#linearGradient-13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5501875,7.09365625 C5.50803125,7.09365625 7.10171875,5.49996875 7.10171875,3.54615625 C7.10171875,1.59234375 5.50803125,0 3.5501875,0 C1.59503125,0 0,1.59234375 0,3.54615625 C0,5.49996875 1.59503125,7.09365625 3.5501875,7.09365625",
    id: "Fill-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(10.702969, 14.903531)",
    fill: "url(#linearGradient-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3461875,4.687 C3.63753125,4.687 4.69103125,3.6335 4.69103125,2.34215625 C4.69103125,1.05215625 3.63753125,0 2.3461875,0 C1.0535,0 0,1.05215625 0,2.34215625 C0,3.6335 1.0535,4.687 2.3461875,4.687",
    id: "Fill-28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(15.596369, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34484375,4.68673125 C3.63753125,4.68673125 4.69103125,3.63323125 4.69103125,2.34323125 C4.69103125,1.0518875 3.63753125,-0.00026875 2.34484375,-0.00026875 C1.0535,-0.00026875 0,1.0518875 0,2.34323125 C0,3.63323125 1.0535,4.68673125 2.34484375,4.68673125",
    id: "Fill-31",
    fill: "#62EBB9",
    mask: "url(#mask-16)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.8358406,56.969625 C26.9855906,56.969625 29.5534969,54.4030625 29.5534969,51.2573438 C29.5534969,48.111625 26.9855906,45.5450625 23.8358406,45.5450625 C20.6847469,45.5450625 18.1168406,48.111625 18.1168406,51.2573438 C18.1168406,54.4030625 20.6847469,56.969625 23.8358406,56.969625",
    id: "Fill-19",
    fill: "#62EBB9",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52075938,9.9115 C4.50035313,9.9115 5.29585313,9.11465625 5.29585313,8.13775 C5.29585313,7.16084375 4.50035313,6.364 3.52075938,6.364 C2.54250938,6.364 1.74566563,7.16084375 1.74566563,8.13775 C1.74566563,9.11465625 2.54250938,9.9115 3.52075938,9.9115",
    id: "Fill-34",
    fill: "#62EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2608875,21.511825 C30.154825,21.511825 34.1457625,17.5249187 34.1457625,12.6363562 C34.1457625,7.74645 30.154825,3.75954375 25.2608875,3.75954375 C20.3656062,3.75954375 16.3746687,7.74645 16.3746687,12.6363562 C16.3746687,17.5249187 20.3656062,21.511825 25.2608875,21.511825",
    id: "Fill-36",
    fill: "#2CB5D6",
    opacity: 0.78
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    transform: "translate(13.518125, 16.220406)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#F8F8F8",
    mask: "url(#mask-18)",
    points: "-0.58184375 32.0336563 32.6517812 32.0336563 32.6517812 -0.5831875 -0.58184375 -0.5831875"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(13.518125, 16.220406)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-43"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#575756",
    mask: "url(#mask-20)",
    points: "-0.58184375 32.0336563 27.0765625 32.0336563 27.0765625 -0.5831875 -0.58184375 -0.5831875"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-47",
    transform: "translate(26.346906, 20.936969)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-46"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    fill: "#FFFFFF",
    mask: "url(#mask-22)",
    points: "-0.5831875 6.87328125 6.99690625 6.87328125 6.99690625 -0.58184375 -0.5831875 -0.58184375"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    transform: "translate(26.346906, 36.664219)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-49"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#575756",
    mask: "url(#mask-24)",
    points: "-0.5831875 6.8719375 6.99690625 6.8719375 6.99690625 -0.5831875 -0.5831875 -0.5831875"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.0986906,5.57051562 C46.2084719,7.03654687 52.1680031,10.5934531 55.6832531,15.7144844 C54.9697219,20.8731406 50.5393781,24.8479531 45.1764719,24.8479531 C39.3204094,24.8479531 34.5715969,20.1045156 34.5715969,14.2524844 C34.5715969,10.6606406 36.3614719,7.48670312 39.0986906,5.57051562",
    id: "Fill-51",
    fill: "#62EBB9",
    opacity: 0.78
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(16.526781, 39.753500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.261875 C0,9.71128125 2.8165,12.5250937 6.2699375,12.5250937 L6.2699375,12.5250937 C9.723375,12.5250937 12.5385313,9.71128125 12.5385313,6.261875 L12.5385313,6.261875 C12.5385313,2.81246875 9.723375,0 6.2699375,0 L6.2699375,0 C2.8165,0 0,2.81246875 0,6.261875",
    id: "Fill-16",
    fill: "url(#linearGradient-27)",
    opacity: 0.78,
    mask: "url(#mask-26)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYinYangIcon);
export default __webpack_public_path__ + "static/media/yin-yang-icon.0dff29ed22855a61edecd741b15d8eea.svg";
export { ForwardRef as ReactComponent };